(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('checkListData', {
        templateUrl: 'views/components/views/checkListData/checkListData.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'base64', 'translateService', 'modalService', 'checkListDataService', function ($stateParams, stateService, base64, translateService, modalService, checkListDataService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let checkListDataKeyno = $stateParams.checklistdata_keyno;
            let updatingDataFromResponse = false;
            let changeTimer = null;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                //isHtml: true,
                setting: {},
                inputListCheckListDatas: {},
                lockedSave: false,
                lockedSaveAndApprove: false,
                lockedDelete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

    		// #region LOAD PROCEDURE FUNCTIONS
    		
            async function loadSetting() {
                vm.model.setting = (await checkListDataService.getSetting({ checklistdata_keyno: checkListDataKeyno }))[0];

                if (vm.model.setting.report_html_base64 > '') {
                    vm.model.setting.report_html = base64.urldecode(vm.model.setting.report_html_base64);
                }
            }

            async function loadCheckListDatas() {
                vm.model.inputListCheckListDatas = (await checkListDataService.listCheckListDatas({ checklistdata_keyno: checkListDataKeyno }))[0];

                for (let i = 0; i < vm.model.inputListCheckListDatas.checklistitems.length; i++) {
                    validateCheckListData(i);
                }
            }

            // #endregion LOAD PROCEDURE FUNCTIONS

            // #region CHANGE FUNCTIONS

            vm.checkListDataOnChange = function (index) {
                if (updatingDataFromResponse) return;

                setTimeout(() => validateCheckListData(index), 50);

                let cldList = vm.model.inputListCheckListDatas.checklistitems;

                if (cldList === undefined || cldList[index] === undefined) return;

                let cldItem = cldList[index];

                if (cldItem.cv === undefined || cldItem.cv !== '1') return;

                let done = false;
                let timerMS = 0;

                switch (cldItem.elementtype) {
                    case 'DT':
                    case 'CL':
                    case 'CB':
                    case 'CS':
                        timerMS = 20;
                        break;
                    default:
                        timerMS = 500;
                }

                if (changeTimer) {
                    done = false;
                    clearTimeout(timerMS);
                }

                async function finishedTyping() {
                    if (done) {
                        let cldConnectedData = [];

                        for (let c = 0; c < cldItem.cvs.length; c++) {
                            for (let d = 0; d < cldList.length; d++) {
                                if (cldItem.cvs[c].clik === cldList[d].checklistitem_keyno) {
                                    cldConnectedData.push({
                                        cii: cldList[d].checklistitem_keyno,
                                        civ: cldList[d].itemvalue
                                    });
                                    break;
                                }
                            }
                        }

                        let updateData = [];

                        checkListDataService.computeValidation({
                            item_id: cldItem.checklistitem_keyno,
                            item_value: cldItem.itemvalue,
                            cvd: cldConnectedData
                        }).then(function (response) {
                            if (response.errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response.errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                        }
                                    }]
                                });
                            }

                            if (response.outputresult) {
                                updatingDataFromResponse = true;
                                updateData = response.outputresult;

                                for (let u = 0; u < updateData.length; u++) {
                                    for (let v = 0; v < cldList.length; v++) {
                                        if (updateData[u].clik === cldList[v].checklistitem_keyno && updateData[u].cliv) {
                                            cldList[v].itemvalue = updateData[u].cliv;
                                            validateCheckListData(v);
                                            break;
                                        }
                                    }
                                }

                                updatingDataFromResponse = false;
                            }
                        });

                        return;
                    }

                    done = true;

                    changeTimer = setTimeout(finishedTyping, timerMS);
                }

                finishedTyping();
            }

            async function validateCheckListData(index) {
                if (vm.model.inputListCheckListDatas.checklistitems[index].elementtype === 'CS' || vm.model.inputListCheckListDatas.checklistitems[index].elementtype === 'CB' || vm.model.inputListCheckListDatas.checklistitems[index].elementtype === 'CL') checkDown(index);
            }

            async function checkDown(index) {
                let newItemValue = vm.model.inputListCheckListDatas.checklistitems[index].itemvalue;
                let checkListItemKeyno = vm.model.inputListCheckListDatas.checklistitems[index].checklistitem_keyno;

                for (let i = index + 1; i < vm.model.inputListCheckListDatas.checklistitems.length; i++) {
                    if (vm.model.inputListCheckListDatas.checklistitems[i].dep1_checklistitem_keyno === checkListItemKeyno) {
                        if (vm.model.inputListCheckListDatas.checklistitems[i].dep1_value === newItemValue) {
                            vm.model.inputListCheckListDatas.checklistitems[i].dep1_visible = '1';
                        } else {
                            vm.model.inputListCheckListDatas.checklistitems[i].dep1_visible = '0';
                        }
                    }
                }

                for (let j = index + 1; j < vm.model.inputListCheckListDatas.checklistitems.length; j++) {
                    if (vm.model.inputListCheckListDatas.checklistitems[j].dep2_checklistitem_keyno === checkListItemKeyno) {
                        if (vm.model.inputListCheckListDatas.checklistitems[j].dep2_value === newItemValue) {
                            vm.model.inputListCheckListDatas.checklistitems[j].dep2_visible = '1';
                        } else {
                            vm.model.inputListCheckListDatas.checklistitems[j].dep2_visible = '0';
                        }
                    }
                }
            }

            // #endregion CHANGE FUNCTIONS

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'pictures':
                        checkListDataService.saveObj({
                            checklistdata_keyno: vm.model.inputListCheckListDatas.checklistdata_keyno,
                            checklist_keyno: vm.model.inputListCheckListDatas.checklist_keyno,
                            checklist_name: vm.model.inputListCheckListDatas.checklist_name,
                            approve: '0',
                            checklistitems: vm.model.inputListCheckListDatas.checklistitems.map(function (a) {
                                return {
                                    "i": a.checklistitemdata_keyno,
                                    "v": a.itemvalue
                                };
                            })
                        }).then((response) => {
                            if (response[0] && response[0].errorcode !== '0') {
                            	modalService.show({
                            		type: 'warning',
                            		title: translations.error,
                            		message: response[0].errormessage,
                            		buttons: [{
                            			label: translations.ok,
                            			cssClass: 'btn-warning',
                            			action: (dialogItself) => {
                            				dialogItself.close();
                            			}
                            		}]
                            	});
                            } else {
                                state = 'pictures';

                                go({
                                    argtype: 'checklistdata_keyno',
                                    argvalue: checkListDataKeyno
                                });
                            }
                        });
                        break;
                    case 'selectreport':
                        go({
                            webpage_name: stateService.getCurrentName(),
                            argtype: 'checklistdata_keyno',
                            argvalue: checkListDataKeyno
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                checkListDataService.saveObj({
                    checklistdata_keyno: vm.model.inputListCheckListDatas.checklistdata_keyno,
                    checklist_keyno: vm.model.inputListCheckListDatas.checklist_keyno,
                    checklist_name: vm.model.inputListCheckListDatas.checklist_name,
                    approve: '0',
                    checklistitems: vm.model.inputListCheckListDatas.checklistitems.map(function (a) {
                        return {
                            "i": a.checklistitemdata_keyno,
                            "v": a.itemvalue
                        };
                    })
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                	    modalService.show({
                		    type: 'warning',
                		    title: translations.error,
                		    message: response[0].errormessage,
                		    buttons: [{
                			    label: translations.ok,
                			    cssClass: 'btn-warning',
                			    action: (dialogItself) => {
                				    dialogItself.close();
                				    vm.model.lockedSave = false;
                			    }
                		    }]
                	    });
                    } else {
                	    vm.model.lockedSave = false;
                	    stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON APPROVE PROCEDURE FUNCTION CALL

            vm.saveAndApproveChanges = function () {
                vm.model.lockedSaveAndApprove = true;

                checkListDataService.saveObj({
                    checklistdata_keyno: vm.model.inputListCheckListDatas.checklistdata_keyno,
                    checklist_keyno: vm.model.inputListCheckListDatas.checklist_keyno,
                    checklist_name: vm.model.inputListCheckListDatas.checklist_name,
                    approve: '1',
                    checklistitems: vm.model.inputListCheckListDatas.checklistitems.map(function (a) {
                        return {
                            "i": a.checklistitemdata_keyno,
                            "v": a.itemvalue
                        };
                    })
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                	    modalService.show({
                		    type: 'warning',
                		    title: translations.error,
                		    message: response[0].errormessage,
                		    buttons: [{
                			    label: translations.ok,
                			    cssClass: 'btn-warning',
                			    action: (dialogItself) => {
                				    dialogItself.close();
                				    vm.model.lockedSaveAndApprove = false;
                			    }
                		    }]
                	    });
                    } else {
                	    vm.model.lockedSaveAndApprove = false;
                	    stateService.back();
                    }
                });
            }

            // #endregion BUTTON APPROVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    checkListDataService.deleteItem({ checklistdata_keyno: checkListDataKeyno }).then(() => {
                        vm.model.lockedDelete = false;
                        stateService.back();
                    }, () => vm.model.lockedDelete = false);
                }, () => vm.model.lockedDelete = false);
            }

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                loadSetting();
                loadCheckListDatas();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
